<div class="village_vision_column document_column" *ngIf="aboutVillageSettings" >
  <div class="custom_heading">
    <h2 class="title">
      Village Vision </h2>
  </div>
  <div class="document_list">
    <ul>
      <li>
        <div class="media">
          <div class="media-body" *ngIf="lang==='en'" [innerHtml]="aboutVillageSettings.vision.en_content">

          </div>
          <div class="media-body"  *ngIf="lang==='te'" [innerHtml]="aboutVillageSettings.vision.te_content">

          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
